import { OnInit } from '@angular/core';
import * as jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GLOBAL } from 'src/app/services/global';
var Acta_expedienteComponent = /** @class */ (function () {
    function Acta_expedienteComponent(fb, _SeguimService, dialog, _formService, spinner, _route) {
        this.fb = fb;
        this._SeguimService = _SeguimService;
        this.dialog = dialog;
        this._formService = _formService;
        this.spinner = spinner;
        this._route = _route;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.acta = { id_solicitud: '', fecha_acta: null, encabezado: '', notas: '', notas1: '' };
        this.observ = [{ id: '', observaciones: '', norma: '' }];
    }
    Acta_expedienteComponent.prototype.ngOnInit = function () {
        this.getActa();
    };
    Acta_expedienteComponent.prototype.ngAfterViewInit = function () {
    };
    Acta_expedienteComponent.prototype.getActa = function () {
        var _this = this;
        this.exp = JSON.parse(localStorage.getItem("solicitud_exp"));
        this.spinner.show();
        this._SeguimService.getActa(this.exp[0].solicitud).subscribe(function (response) {
            if (response.message) {
                alert("El número de solicitud que estas buscando no existe en los registros");
                _this.spinner.hide();
            }
            else {
                _this.acta = response.acta;
                _this.observ = response.observ;
                _this.spinner.hide();
            }
        }, function (error) {
            _this.spinner.hide();
        });
    };
    Acta_expedienteComponent.prototype.cleanData = function () {
        this.acta = { id_solicitud: '', fecha_acta: null, encabezado: '', notas: '', notas1: '' };
        this.observ = [{ id: '', observaciones: '', norma: '' }];
    };
    Acta_expedienteComponent.prototype.captureScreen = function () {
        this.exp = JSON.parse(localStorage.getItem("solicitud_exp"));
        var pdf;
        var imgData;
        var totalPages;
        pdf = new jsPDF('p', 'mm', 'legal');
        var doc_width = 8.5; // A4 measures 210 × 297 millimeters or 8.27 × 11.69 inches
        var doc_height = 13.00;
        var aspect = doc_height / doc_width;
        var dpi = 96; // default
        var img_width = doc_width * dpi;
        var img_height = doc_height * dpi;
        var win_width = img_width;
        var win_height = img_height;
        var html2canvasOpts = {
            scale: 1,
            windowHeight: win_height - 3,
        };
        var jsPDFOpts = {
            orientation: 'portrait',
            unit: 'in',
            format: [doc_width, doc_height]
        };
        html2pdf().set({
            margin: [0.50, 0.00, 0.50, 0.00],
            filename: 'Acta ' + this.exp[0].solicitud + '.pdf',
            image: { type: 'jpeg', quality: 0.96 },
            html2canvas: html2canvasOpts,
            jsPDF: jsPDFOpts,
            enableLinks: true,
        }).from(document.getElementById('page1')).save();
    };
    return Acta_expedienteComponent;
}());
export { Acta_expedienteComponent };
